import { Component } from '../component.class';
import { ComponentData } from '../types';

export const resetCfn = (component: Component, values: ComponentData = null): void => {
	if (values === null) return;

	// console.log('reset', values);
	component.categoryId = values.categoryId;
	component.vendorId = values.vendorId;
	component.sku = values.sku;
	component.description = values.description;
	component.placement = values.placement;
	component.application = values.application;
	component.applianceModule = values.applianceModule;
	component.cutout = values.cutout;
	component.size = values.size;
	component.distanceAboveCountertop = values.distanceAboveCountertop;
	component.distanceFrontOfFace = values.distanceFrontOfFace;
	component.distanceBelowCountertop = values.distanceBelowCountertop;
	component.imageCorrection = values.imageCorrection;
	component.dimensions = values.dimensions;
	component.showLabel = values.showLabel;
	component.showImage = values.showImage;
	component.skuOverheadMode = values.skuOverheadMode ?? 'sku';
	component.rules = values.rules;
	component.active = values.active;
	// component.svg = values.svg;
};
